export default [
    {
        path: '/',
        component: require('../components/the-layout-card').default,
        children: [
            {
                path: 'invitations',
                redirect: {
                    name: 'invitations.create'
                }
            },
            {
                path: 'invitations/new',
                name: 'invitations.create',
                component: require('../views/invitations/create').default
            },
            {
                path: 'invitations/new-1',
                component: require('../views/invitations/create-1').default
            }
        ]
    },
    {
        path: '/',
        component: require('../components/the-layout-www').default,
        children: [
            {
                path: 'invitations/:token',
                name: 'invitations.show',
                component: require('../views/invitations/show').default
            }
        ]
    }
]
